<footer class="page-footer">
  <div class="page-container">
    <nav class="page-footer-nav" *ngIf="!isHideNavigation">
      <div class="hidden-lg font-weight-300">&copy; 2025 Глабикс, Глабикс™</div>
      <div class="visible-lg col-3 p-0">
        <h5 class="h5 font-weight-500 mb-5">О системе</h5>
        <div>
          <a subdomainLink="/help/faq" [subdomainLinkType]="subdomainLinksTypes.LANDING">Часто задаваемые вопросы</a>
        </div>
        <div>
          <a subdomainLink="/help" [subdomainLinkType]="subdomainLinksTypes.LANDING">База знаний</a>
        </div>
        <div>
          <a subdomainLink="/contacts" [subdomainLinkType]="subdomainLinksTypes.LANDING">Контакты</a>
        </div>
      </div>
      <div class="visible-lg col-3 p-0">
        <h5 class="h5 font-weight-500 mb-5">Стоимость</h5>
        <div>
          <a subdomainLink="/pricing" [subdomainLinkType]="subdomainLinksTypes.LANDING">Тарифные планы</a>
        </div>
        <div>
          <a subdomainLink="/loyalty-program" [subdomainLinkType]="subdomainLinksTypes.LANDING">Программа лояльности</a>
        </div>
      </div>
      <div class="visible-lg p-0 ml-auto">
        <h5 class="h5 font-weight-500 mb-5">Контакты</h5>
        <div class="font-weight-500 mb-5">
          <a class="text-xl visible-sm" href="tel:+7-939-746-48-46">+7 939 746 48 46</a>
          <a class="hidden-sm" href="tel:+7-939-746-48-46">+7 939 746 48 46</a>
        </div>
        <div class="flex gap-5">
          <div>
            <a href="mailto:hello@glabix.com" class="btn-landing btn-landing--square i i--xl i-envelope"></a>
          </div>
          <div>
            <a href="https://t.me/glabix" class="btn-landing btn-landing--square i i--xl i-paper-plane-2"></a>
          </div>
          <div>
            <a href="https://vk.com/public223050179" class="btn-landing btn-landing--square i i--xl i-vk"></a>
          </div>
        </div>
      </div>
    </nav>

    <div class="visible-xl">
      <div class="page-footer-bottom" [class.p-0]="isHideNavigation">
        <div>&copy; 2025 Глабикс, Глабикс™</div>
        <div class="page-footer-bottom-menu">
          <div>
            <a subdomainLink="/screen/terms" [subdomainLinkType]="subdomainLinksTypes.LANDING"
              >Соглашение пользователя</a
            >
          </div>
          <div>
            <a subdomainLink="/privacy" [subdomainLinkType]="subdomainLinksTypes.LANDING"
              >Политика конфиденциальности</a
            >
          </div>
          <!-- <div>
            <a subdomainLink="/payments" [subdomainLinkType]="subdomainLinksTypes.LANDING"
              >Безопасность онлайн платежей</a
            >
          </div> -->
        </div>
        <div>
          <div class="flex gap-4 items-center justify-center">
            <a class="font-weight-300" href="mailto:hello@glabix.com">hello&#64;glabix.com</a>
          </div>
        </div>
      </div>
    </div>

    <div class="hidden-xl" *ngIf="isHideNavigation">
      <div class="page-footer-bottom flex justify-center">
        <div>&copy; 2025 Глабикс, Глабикс™</div>
      </div>
    </div>
  </div>
</footer>
